/**
 * Gets the symmetric difference for lists A and B. The symmetric difference of listA and listB is the set of elements that appear
 * only in listA or only in listB.
 * @param listA
 * @param listB
 * @returns The symmetric difference for lists A and B.
 */
export function getSymmetricDifference(listA: string[], listB: string[]): string[] {
    return [
        ...listA.filter(item => listB.indexOf(item) < 0), // ListA elements - listB elements
        ...listB.filter(item => listA.indexOf(item) < 0), // listB elements - listA elements
    ];
}
